/**
 * How far this period's running total is from the previous period's at the
 * same point (the same day of the month): positive when spending is under,
 * negative when it is over, null with nothing to compare. A shorter previous
 * period is read at its last day.
 *
 * @param {{ cumulative: number }[]} current - this period's points, to date
 * @param {{ cumulative: number }[]} previous - the previous period's points
 * @returns {number|null}
 */
export function gapToPrevious(current, previous) {
  if (!current?.length || !previous?.length) return null;
  const i = current.length - 1;
  return previous[Math.min(i, previous.length - 1)].cumulative - current[i].cumulative;
}
